const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx"];
const MAX_FILE_SIZE_MB = 20;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_BULK_UPLOAD_COUNT = 100;

const getExtension = (fileName = "") => {
  const parts = String(fileName).toLowerCase().split(".");
  return parts.length > 1 ? parts.pop() : "";
};

export const validateResumeFile = (file) => {
  if (!file) {
    return { valid: false, message: "No file selected" };
  }

  const extension = getExtension(file.name);
  if (!ALLOWED_EXTENSIONS.includes(extension)) {
    return {
      valid: false,
      message: "Only .pdf, .doc and .docx files are allowed",
    };
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    return {
      valid: false,
      message: `File size must be ${MAX_FILE_SIZE_MB} MB or less`,
    };
  }

  return { valid: true, message: "Valid file" };
};

export const validateBulkFiles = (files = []) => {
  if (!files.length) {
    return { valid: false, message: "Please select at least one file" };
  }

  if (files.length > MAX_BULK_UPLOAD_COUNT) {
    return {
      valid: false,
      message: `You can upload up to ${MAX_BULK_UPLOAD_COUNT} files at once`,
    };
  }

  for (const file of files) {
    const result = validateResumeFile(file);
    if (!result.valid) {
      return {
        valid: false,
        message: `${file.name}: ${result.message}`,
      };
    }
  }

  return { valid: true, message: "Valid files" };
};

export const fileValidationConfig = {
  ALLOWED_EXTENSIONS,
  MAX_FILE_SIZE_MB,
  MAX_BULK_UPLOAD_COUNT,
};
